<div class="contacts-list-item-image-container">
  <span>{{ contact.getMonogram() }}</span>
</div>
<div class="contacts-list-item-text">
  <div class="contacts-list-item-name font-size-15" [innerHTML]="contact.getName() | highlight: query"></div>
  <div class="contacts-list-item-subline">
    @if (getFields().length === 1) {
      <div class="items-center">
        <div class="address-icon" [ngClass]="getAddressIconClass(contact.getFields()[0])"></div>
        <span [innerHTML]="contact.getFields()[0].getValue() | highlight: query"></span>
      </div>
    } @else {
      <div class="items-center">
        @for (field of getFields(); track field) {
          <div class="address-icon" [ngClass]="getAddressIconClass(field)"></div>
        }
        <span>{{ getSubLine() }}</span>
      </div>
    }
  </div>
</div>
